import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";
import { append_active_organization_form_data, append_active_organization_id, is_organization_admin_role } from "@/utils/organization_profile";

export default {
  emits: ['create-portal'],
  props: {
    showTrigger: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "user_id": '',
      },
      portal_name: '',
      temporaryPost: null,
      isSubmitting: false,
      isDropdownVisible: false,
      fileName: '',
      topics: [],
      created_by_id: this.created_by,
      portals: [],
      isMaster: false,
      selectedPortals: [],
      selectedMasterPortal: '',
      categories: [],
      selectedPortalId: null,
      selectedTopicId: null,
      selected_visibility: 'public',
      is_visible: true,
      searchQuery: "",
      errors: {
        voice_description: null,
        voice_name: null,
        audio_file: null,
        portal: null,
        segment: null,
        report_description: null
      },
      users: [],
      selectedUserIds: [],
      portal_users: [],
      cbo_domain: false,
      portal_types: [],
      selected_portal_type: null,
      contactEmail: '',
      payload: {},
      soulcity_domain: false,
      school_domain: false
    });
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();

    if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
      this.soulcity_domain = true;
    }
    if (client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }

    this.load_create_portal_options();

    const modal = document.getElementById("portal_modal");
    if (modal) {
      modal.addEventListener("shown.bs.modal", this.load_create_portal_options);
    }
  },
  beforeUnmount() {
    const modal = document.getElementById("portal_modal");
    if (modal) {
      modal.removeEventListener("shown.bs.modal", this.load_create_portal_options);
    }
  },
  computed: {
    can_create_portal() {
      return this.user_details?.user_role === 'admin' || is_organization_admin_role(this.user_details);
    },
    filtered_portal_types() {
      return this.portal_types.filter(type => type.name.toLowerCase() !== 'mentoring');
    },

    portal_id() {
      return this.$route.params.portal_id;
    },
    isPublic() {
      return this.selected_visibility === 'public';
    },
    is_invite_only_portal() {
      return this.selected_visibility === 'private' && String(this.is_visible).toLowerCase() === 'false';
    },
    add_members_label() {
      return this.is_invite_only_portal ? 'Invite Members' : 'Add Members';
    },
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }
      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user =>
        user.first_name.toLowerCase().includes(query) ||
        user.last_name.toLowerCase().includes(query)
      );
    },
    areAllSelected() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    filteredPortals() {
      if (!this.searchQuery) {
        return this.portals.filter(portal =>
          !portal.portal_type || portal.portal_type.name !== 'incident'
        );
      }
      const query = this.searchQuery.toLowerCase();
      return this.portals.filter(portal =>
        (!portal.portal_type || portal.portal_type.name !== 'incident') &&
        portal.name.toLowerCase().includes(query)
      );
    },
    areAllSubPortalsSelected() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
      return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
    },
  },
  watch: {
    portal_types: {
      immediate: true,
      handler() {
        this.set_default_portal_type();
      }
    },
    selected_visibility(value) {
      if (value === 'public') {
        this.is_visible = true;
      }
    }
  },
  methods: {

    getToken() {
      return get_token();
    },
    set_default_portal_type() {
      this.selected_portal_type = this.portal_types.find(
        type => type.name && type.name.toLowerCase().trim() === 'engagement'
      ) || this.portal_types[0] || null;
    },
    load_create_portal_options() {
      this.fetchPortals();
      this.fetch_users();
      this.fecthPortalTypes();
    },

    fetchPortals() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(append_active_organization_id(this.payload)),

        success: (data) => {
          if (this.user_details.user_role === "admin") {
            this.portals = data.portals;
            this.portals = this.portals.filter(
              portal => portal.name?.toLowerCase() !== 'default portal'
            );
          } else {
            const portal = data.portals
            this.portals = portal.filter(portal => portal.has_access == "approved")

          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    toggleSelectAll() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      if (this.areAllSelected) {

        this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
      }
    },
    toggleSelectAllSubPortals() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);

      if (this.areAllSubPortalsSelected) {
        this.selectedPortals = this.selectedPortals.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedPortals = [...new Set([...this.selectedPortals, ...filteredIds])];
      }
    },
    fecthPortalTypes() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_types`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.portal_types = response.portal_types.filter(
              type => type.name.toLowerCase() === 'engagement'
            );
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    createPortal() {

      if (!this.validationPortalForm()) {
        return;
      }

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('portal_name', this.portal_name);
      formData.append('portal_type', this.selected_portal_type?.id || '')
      formData.append('is_master', this.isMaster)
      formData.append('master_portal_id', this.selectedMasterPortal)
      formData.append('contact_email', this.contactEmail)
      formData.append('is_public', this.isPublic);
      formData.append(
        'is_visible',
        this.selected_visibility === 'private'
          ? String(this.is_visible)
          : 'true'
      );
      let baseUrl = '';
      if (this.selected_portal_type?.name === 'publishing') {
        baseUrl = '/publish_portal';   // backend will append ?portal_id=ID
      } else {
        baseUrl = '/view_portal';      // backend will append ?portal_id=ID
      }
      formData.append('base_url', baseUrl);
      this.selectedPortals.forEach(portal_id => {
        formData.append('sub_portals', portal_id);
      });
      this.selectedUserIds.forEach(user_id => {
        formData.append('user_id', user_id);
      });
      formData.append('description', this.description);
      append_active_organization_form_data(formData);

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_portal_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          this.$emit('addPortal', response.message)
          $('#portal_modal').modal('hide');
          this.isDropdownVisible = false;
          const portalId = response.portal.id;
          const portalName = response.portal.name;
          const is_public = response.portal.is_public
          const is_visible = response.portal.is_visible
          const portal_type_name = this.selected_portal_type?.name;

          this.resetPortalForm();

          if (portal_type_name === 'publishing') {
            this.$router.push(`/publish_portal/${portalId}/${portalName}`);
          } else {
            this.$router.push(`/view_portal/${portalId}/${portalName}/${is_public}/${is_visible}`);
          }

        },
        error: (response) => {
          Swal.close();

          const response_error = response.responseJSON;

          if (response_error && response_error.status === "error") {
            this.errors.portal_name = response_error.message;
          } else {
            this.errors.portal_name = "Something went wrong. Please try again.";
            console.error("Unexpected error structure:", response);
          }
        },

        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    resetPortalForm() {
      this.selectedUserIds = [];
      this.selectedPortals = [];
      this.portal_name = '';
      this.description = '';
      this.contactEmail = '';
      this.selectedMasterPortal = '';
      this.isMaster = false;
      this.selected_visibility = 'public';
      this.is_visible = true;
    },
    fetch_users() {
      return new Promise((resolve) => {

        const groupId = this.$route.params.group_id;
        $.ajax({
          type: 'GET',
          data: { group_id: groupId },
          url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          success: (response) => {
            this.users = response.data.users_list.filter(user => user.id != this.user_details.user_id);
            resolve();
          },
        });
      });
    },
    validationPortalForm() {
      this.errors = {};
      let valid = true;

      if (!this.portal_name) {
        this.errors.portal_name = 'Portal name is required';
        valid = false;
      }

      if (!this.selected_portal_type?.id) {
        this.errors.portal_type = 'Portal type is required';
        valid = false;
      }

      return valid;
    },
    addPortalMembers() {
      if (this.selectedUserIds.length === 0) {
        this.errors.user_ids = "Please select at least one member.";
        return;
      }
      $('#portal_member_modal').modal('hide');
    },
    confirmSelectedPortals() {
      $('#select_portals_modal').modal('hide');
    },
  },
}
